module.exports = __webpack_public_path__ + "static/media/chimichanga_logo.3e21bc3b.png";